export default __webpack_public_path__ + "static/media/black-loader-transperent.458a4e9c.gif";